import { useEffect } from 'react';
import { useInterval } from 'usehooks-ts';
import useAuth from '~/hooks/useAuth';
import { usePaymentMethodBannerState } from '~/hooks/usePaymentMethodBannerState';

import BlockPurchaseBanner from './blockPurchases/blockPurchasesBanner';
import FailedRebillBanner from './failedRebill/failedRebillBanner';
import MissingPaymentMethodBanner from './paymentMethods/MissingPaymentMethodBanner';

interface BannerProps {
  onPaymentMethodsChange?: (hasPaymentMethods: boolean) => void;
}

const GlobalBanners: React.FC<BannerProps> = ({ onPaymentMethodsChange }) => {
  const { user } = useAuth();
  const userId = parseInt(user?.userId ?? '');
  const { hasPaymentMethods, renewalAlert, shouldPoll, checkPaymentMethods } =
    usePaymentMethodBannerState(userId, onPaymentMethodsChange);

  useInterval(checkPaymentMethods, shouldPoll ? 5000 : null);

  useEffect(() => {
    checkPaymentMethods();
  }, []);

  return (
    <div className="flex flex-col">
      <MissingPaymentMethodBanner
        hasPaymentMethods={hasPaymentMethods}
        renewalAlert={renewalAlert}
      />
      <FailedRebillBanner />
      <BlockPurchaseBanner />
    </div>
  );
};

export default GlobalBanners;
